import React from 'react'

import { EuiFieldText, EuiFormRow, EuiSwitch } from '@elastic/eui'

import { FormStack } from 'features/builders/agency/FormStack'
import { CreativeLinkMode, CreativeLinks, isValidUrl } from 'features/builders/agency/quickCampaignModels'

export interface ICreativeLinkSettings {
  idPrefix: string
  links: CreativeLinks
  showErrors: boolean
  onModeChange?: (mode: CreativeLinkMode) => void
  onSharedLinkChange: (link: string) => void
}

export const CreativeLinkSettings: React.FC<ICreativeLinkSettings> = ({ idPrefix, links, showErrors, onModeChange, onSharedLinkChange }) => {
  const isUnique = links.mode === CreativeLinkMode.Unique
  const isSharedLinkInvalid = (showErrors || links.sharedLink.trim().length > 0) && !isValidUrl(links.sharedLink)

  return (
    <FormStack>
      {!isUnique && (
        <EuiFormRow id={`${idPrefix}-sharedLink`} label='Website Link' helpText='Used for every creative' isInvalid={isSharedLinkInvalid} error='Enter a valid link'>
          <EuiFieldText placeholder='https://...' value={links.sharedLink} onChange={e => onSharedLinkChange(e.target.value)} isInvalid={isSharedLinkInvalid} />
        </EuiFormRow>
      )}
      {onModeChange && (
        <EuiFormRow id={`${idPrefix}-uniqueLinks`} helpText={isUnique ? 'Enter the link on each creative below' : undefined}>
          <EuiSwitch label='Use a different link for each creative' checked={isUnique} onChange={e => onModeChange(e.target.checked ? CreativeLinkMode.Unique : CreativeLinkMode.Shared)} />
        </EuiFormRow>
      )}
    </FormStack>
  )
}
